import React, { useState } from "react";
import './EditProfileProvinceState.css';

const EditProfileProvinceState = (props) => {
    const [province, setProvince] = useState("");

    return (
        <div className="edit-profile-state-province-profile">
            <div className="first-name-h-eading">
                <div className="label-19 nunito-semi-bold-shuttle-gray-14px">Province/State of residence for tax purposes</div>
            </div>
            <div className="overlap-group2-7">
                <select className="group-10000063610 border-1px-mischka nunito-semi-bold-haiti-11-7px" onChange={(e) => {
                    const selectedProvince = e.target.value;
                    setProvince(selectedProvince)
                    props.getProvinceData(selectedProvince);
                }}>
                    <option value=""></option>
                    <option value="NS">Nova Scotia</option>
                    <option value="AB">Alberta</option>
                    <option value="BC">British Columbia</option>
                    <option value="MB">Manitoba</option>
                    <option value="NB">New Brunswick</option>
                    <option value="NL">NewFoundLand</option>
                    <option value="NT">Northwest Territories</option>
                    <option value="NU">Nunavut</option>
                    <option value="ON">Ontario</option>
                    <option value="PEI">Prince Edward Island</option>
                    <option value="QC">Quebec</option>
                    <option value="SK">Saskatchewan</option>
                    <option value="YT">Yukon</option>
                </select>
            </div>
        </div>
    )
}

export default EditProfileProvinceState;